import moment from 'moment';
import {
  isClosedInPeriod,
  isDateBetween,
  isFactInPeriod,
  isPlanInPeriod,
} from './reportChartFilters';

const isDateBetweenChecker = (
  reqArr,
  onlyThisPeriod,
  periodStart,
  periodEnd
) => {
  const obj = {
    receive: [],
    complete: [],
    annulled: [],
    period: [],
  };

  const createdInPeriod = reqArr.filter((item) =>
    isDateBetween(item.createDateTime, periodStart, periodEnd)
  );

  const createdNotInPeriod = reqArr.filter(
    (item) => !isDateBetween(item.createDateTime, periodStart, periodEnd)
  );

  if (!onlyThisPeriod) {
    createdNotInPeriod.forEach((item) => {
      const plan = isPlanInPeriod(item, periodStart, periodEnd);
      const fact = isFactInPeriod(item, periodStart, periodEnd);
      const close = isClosedInPeriod(item, periodStart, periodEnd);

      if ((plan || fact || close) && item.status !== 'Аннулирована') {
        obj.complete.push(item);
        obj.period.push(item);
      } else if (item.status === 'Аннулирована') {
        obj.annulled.push(item);
      }
    })
    createdInPeriod.forEach((item) => {
      const plan = isPlanInPeriod(item, periodStart, periodEnd);
      const fact = isFactInPeriod(item, periodStart, periodEnd);
      const close = isClosedInPeriod(item, periodStart, periodEnd);

      obj.receive.push(item);
      obj.period.push(item);

      if (item.status !== 'Аннулирована' && (plan || fact || close)) {
        obj.complete.push(item);
        obj.period.push(item);
      } else if (item.status === 'Аннулирована') {
        obj.annulled.push(item);
      }
    });
  } else {
    createdInPeriod.forEach((item) => {
      const plan = isPlanInPeriod(item, periodStart, periodEnd);
      const fact = isFactInPeriod(item, periodStart, periodEnd);
      const close = isClosedInPeriod(item, periodStart, periodEnd);

      obj.receive.push(item);
      obj.period.push(item);

      if (item.status !== 'Аннулирована' && (plan || fact || close)) {
        obj.complete.push(item);
        obj.period.push(item);
      } else if (item.status === 'Аннулирована') {
        obj.annulled.push(item);
      }
    });
  }

  return obj;
};

export const dashboardRequestsSorter = (
  reqObj,
  onlyThisPeriod = false,
  createDateRange
) => {
  const data = {
    receive: [],
    complete: [],
    annulled: [],
    period: [],
  };

  const [rawStart, rawEnd] = createDateRange.split(',');

  const periodStart = rawStart ? moment.utc(rawStart) : null;
  const periodEnd = rawEnd ? moment.utc(rawEnd).endOf('day') : null;

  Object.keys(reqObj).forEach((key) => {
    if (key === 'new') {
      const { receive, complete, period } = isDateBetweenChecker(
        reqObj[key],
        onlyThisPeriod,
        periodStart,
        periodEnd
      );
      data.receive.push(...receive);
      data.complete.push(...complete);
      data.period.push(...period);
    }
    if (key === 'inWork') {
      const { receive, complete, period } = isDateBetweenChecker(
        reqObj[key],
        onlyThisPeriod,
        periodStart,
        periodEnd
      );
      data.receive.push(...receive);
      data.complete.push(...complete);
      data.period.push(...period);
    }
    if (key === 'done') {
      const { receive, complete, period } = isDateBetweenChecker(
        reqObj[key],
        onlyThisPeriod,
        periodStart,
        periodEnd
      );
      data.receive.push(...receive);
      data.complete.push(...complete);
      data.period.push(...period);
    }
    if (key === 'closed') {
      const { receive, complete, period } = isDateBetweenChecker(
        reqObj[key],
        onlyThisPeriod,
        periodStart,
        periodEnd
      );
      data.receive.push(...receive);
      data.complete.push(...complete)
      data.period.push(...new Set(period));
    }
    if (key === 'annulled') {
      const { receive, complete, annulled, period } = isDateBetweenChecker(
        reqObj[key],
        onlyThisPeriod,
        periodStart,
        periodEnd
      );
      data.period.push(...period);
      data.receive.push(...receive);
      data.complete.push(...complete);
      data.annulled.push(...annulled);
    }
  });

  return {
    receive: [...new Set(data.receive)],
    complete: [...new Set(data.complete)],
    annulled: [...new Set(data.annulled)],
    period: [...new Set(data.period)],
  };
};
